import type { CogentLive } from "../chat/chat-view";
import type { WidgetActions } from "../use-widget-actions";
import s from "../cogent.module.css";

/** The native controller owns delivery, observation deadlines, and error recovery. */
export function WidgetLiveStatus({ live }: { live: CogentLive | null }) {
  return live?.recovery ? (
    <output
      className={s.soft}
      data-testid="cogent-recovery"
      role={live.recovery.attention ? "alert" : undefined}
    >
      {live.recovery.title}
      {live.recovery.detail ? `: ${live.recovery.detail}` : ""}
    </output>
  ) : null;
}

/** What the cogent is doing right now, just above where the viewer writes. */
export function WidgetStatusLine({ actions }: { actions: WidgetActions }) {
  if (actions.wake && actions.offline)
    return (
      <p className={s.statusLine}>
        Offline ·{" "}
        <button
          type="button"
          className={s.link}
          disabled={actions.busy}
          onClick={actions.wake}
        >
          Start
        </button>
      </p>
    );

  return actions.statusLine ? (
    <output className={s.statusLine} data-testid="cogent-doing">
      <span className={s.thinking}>{actions.statusLine}</span>
    </output>
  ) : null;
}
